var anywhere;
var CTHRU = 'rgba(0, 0, 0, 0.01)';
var OFFSTAGE = 9999;

anywhere_pens = {
    fgSpeech: '#444444',
    bgSpeech: '#eeeeee',
    txSpeech: '#444444',
    txLetter: 'black',
    txLetterHi: 'red',
    bgLetter: '#ece8e4'
};

anywhere_fonts = {
    letter: '12px Quando',
    speech: '12px Quando'
};

function media(f) {return '/anywhere/media/' + f; }

var 
    thisGame = {
    /** supportMedia - Generate a path to a given file within the public space of the web page/app.
     *  The global constant gc.root gives any path common to all files used by the app.
     *  The supplied filename may include subdirectories.
     */
    supportMedia: 
        function (s) {
            return '/anywhere/' + s;
        }
    };

function ujPut(o, x, y, assetName) {
    o.x = x;
    o.y = y;
    o.name = assetName || ('ujPut(' + x + ',' + y + ')');

    return o;
}

function d2(deg) {
    return deg * (Math.PI / 180);
}

function goRoom(newRoom) {
    newRoom.preload();

    anywhere.queue.on('complete', function (evt, data) {
        data.room.load().enter();
        createjs.Tween.get(anywhere.stage).to({alpha: 1}, 1000);

    }, null, true, {room: newRoom});
}
